// extracted by mini-css-extract-plugin
export var equalColumn = "_h6-0";